"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
require("./RevealablePassword.scss");
var _react = _interopRequireDefault(require("react"));
var _Input = _interopRequireDefault(require("./Input"));
var _Button = _interopRequireDefault(require("./Button"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ReduxFormRevealablePassword = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ReduxFormRevealablePassword, _React$Component);
  var _super = _createSuper(ReduxFormRevealablePassword);
  function ReduxFormRevealablePassword(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ReduxFormRevealablePassword);
    _this = _super.call(this, props);
    _this.state = {
      showPassword: false
    };
    return _this;
  }
  (0, _createClass2["default"])(ReduxFormRevealablePassword, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var showPassword = this.state.showPassword;
      var fieldType = showPassword ? 'text' : 'password';
      var iconStyle = showPassword ? 'icon icon-eye-closed' : 'icon icon-eye-open';
      return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
        groupClassName: "arc-RevealablePassword",
        addonAfter: /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          onClick: function onClick() {
            return _this2.setState(function (state) {
              return _objectSpread(_objectSpread({}, state), {}, {
                showPassword: !state.showPassword
              });
            });
          },
          bsStyle: "link"
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "showHideIcon ".concat(iconStyle)
        })),
        name: "password",
        type: fieldType
      }, this.props));
    }
  }]);
  return ReduxFormRevealablePassword;
}(_react["default"].Component);
var _default = exports["default"] = ReduxFormRevealablePassword;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/RevealablePassword.js
// module id = 2840
// module chunks = 25